"use client";

import { c as _c } from "react/compiler-runtime";
import { ReviewFilter } from "@/features/hospital/ui/organisms";
import { useEffect, useRef } from "react";
import NoDataTemplates from "@/shared/ui/templates/NoData";
interface ReviewListProps {
  isEmpty: boolean;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  isCollection: boolean;
  children: React.ReactNode;
}
const ReviewList = t0 => {
  const $ = _c(12);
  const {
    isEmpty,
    fetchNextPage,
    hasNextPage,
    isCollection,
    children
  } = t0;
  const loadMoreRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== fetchNextPage || $[1] !== hasNextPage) {
    t1 = () => {
      if (!loadMoreRef.current || !hasNextPage) {
        return;
      }
      const observer = new IntersectionObserver(t3 => {
        const [entry] = t3;
        if (entry.isIntersecting) {
          fetchNextPage();
        }
      }, {
        rootMargin: "200px"
      });
      observer.observe(loadMoreRef.current);
      return () => observer.disconnect();
    };
    t2 = [fetchNextPage, hasNextPage];
    $[0] = fetchNextPage;
    $[1] = hasNextPage;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ReviewFilter />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== children || $[6] !== isCollection || $[7] !== isEmpty) {
    t4 = isEmpty ? <NoDataTemplates pageName={isCollection ? "review" : "analysis"} className="py-10" /> : children;
    $[5] = children;
    $[6] = isCollection;
    $[7] = isEmpty;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div ref={loadMoreRef} style={{
      height: 1
    }} />;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4) {
    t6 = <div className="flex-1 flex flex-col">{t3}{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  return t6;
};
export default ReviewList;